import { FC, useEffect, useState } from 'react';

import {
  Paragraph,
  Col,
  Title,
  StaleLoader,
  StaleInputRadioNew,
} from 'components';
import { Notify } from 'utils';
import { useTheme } from 'styled-components';
import { updateEntitySettings } from 'services/firebase';
import { useStoreState } from 'state';
import { COMMITTED_CURRENCY_QUESTIONS } from 'variables';
import { useHistory, useRouteMatch } from 'react-router';
import { useQuery } from 'hooks';
import Button from 'components/shared/Button/Button';

const StepTwo: FC = () => {
  const theme = useTheme();
  const history = useHistory();
  const urlQuery = useQuery();
  const { url } = useRouteMatch();
  const { userEntity } = useStoreState((state) => state.UserState);
  const [isLoading, setIsLoading] = useState(!userEntity);
  const [question, setQuestion] = useState('');

  const onContinue = async () => {
    try {
      setIsLoading(true);

      const response = await updateEntitySettings({
        riskSettingCommittedCashFlows: question,
      });

      if (response?.data?.success) {
        urlQuery.set('step', '3');
        history.push(`${url}?${urlQuery.toString()}`);
      } else {
        Notify.error(response?.data?.message ?? '');
        setIsLoading(false);
      }
    } catch (error) {
      Notify.error(error.response?.data?.error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userEntity.riskSettingCommittedCashFlows) {
      setQuestion(userEntity.riskSettingCommittedCashFlows);
    }
  }, [userEntity]);

  return isLoading ? (
    <StaleLoader size="large" />
  ) : (
    <>
      <Title mb mbValue={theme.spacing.xxl} variant="h1">
        Committed cashflows
      </Title>

      <Col justifyContent="center">
        <Paragraph mb mbValue={theme.spacing.xl}>
          If you have accounts payables and receivables in foreign currencies,
          leaving currency risks unmanaged exposes your finances to potential
          losses, even if at times it may seem worthwhile to wait for better
          rates.
        </Paragraph>

        <Title variant="h3" mb mbValue={theme.spacing.xxl}>
          How do you want to manage committed currency risks?
        </Title>
        <form>
          <Col rowGap={theme.spacing.m} mb mbValue={theme.spacing.xxxl}>
            {COMMITTED_CURRENCY_QUESTIONS.map(({ id, value, name }) => (
              <StaleInputRadioNew
                key={id}
                id={value}
                label={name}
                checked={question === value}
                onChange={() => setQuestion(value)}
              />
            ))}
          </Col>

          <Button
            disabled={isLoading || !question}
            isLoading={isLoading}
            onClick={onContinue}
          >
            Continue
          </Button>
        </form>
      </Col>
    </>
  );
};

export default StepTwo;
